<template>
  <WsMain>
    <WsCRUD
      v-if="isMounted"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :showExpand="false"
      :pageMode="true"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      :isCreatable="false"
      :customUrlParams="customUrlParams"
      @filter-select="$_onFilterSelect($event)"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/act_idtf_review";
import idtfModel from "@/models/act_idtf_assignment";
export default {
  data: () => ({
    isMounted: false,
    modelName: model.modelName,
    label: model.label,
    fields: idtfModel.fields,
    filterSelects: [
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "idtf_status",
        defaultValue: "2",
        items: [
          {
            text: "覆核中",
            value: "2",
          },
          {
            text: "已完成",
            value: "3",
          },
        ],
      },
    ],
    filterProps: {},
    showFields: [
      "act_version",
      "idtf_reviewers",
      "idtf_owners",
      "idtf_backups",
      "idtf_updated_admin",
      "idtf_updated_at",
      "idtf_overall_reviewer",
      "idtf_overall_reviewed_at",
    ],
    customUrlParams: {
      status: '2'
    },
  }),
  methods: {
    $_onFilterSelect($event) {
      this.filterProps = {
          ...$event,
        };
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>